// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xzpg","input":"styles_input__2GPPJ"};